module.exports = __webpack_public_path__ + "static/media/services-project-bg-1.86a17cd5.svg";